module.exports = __webpack_public_path__ + "img/120.e3c19efb.jpg";